/* L'Escapade Cosmétique — Scroll Animations (progressive enhancement) */

(function () {
  'use strict';

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('luxe-hidden');
          entry.target.classList.add('luxe-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px 80px 0px' }
  );

  function initAnimations() {
    document
      .querySelectorAll('.luxe-animate, .luxe-animate-stagger')
      .forEach(function (el) {
        /* Only hide elements that are NOT already in the viewport */
        var rect = el.getBoundingClientRect();
        if (rect.top > window.innerHeight) {
          el.classList.add('luxe-hidden');
        }
        observer.observe(el);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
})();

/* Header dropdown is pure CSS (:hover on <li>) — no JS needed */

/* ── Collection title override for /collections/all ── */
(function () {
  if (window.location.pathname === '/collections/all') {
    var heading = document.querySelector('h1');
    if (heading && heading.textContent.trim() === 'Produits') {
      heading.textContent = 'Tous nos produits';
    }
  }
})();

/* ── Product Tabs — Description / Utilisation ── */
(function () {
  'use strict';

  function initProductTabs() {
    /* Only run on product pages */
    var productInfo = document.querySelector('.product-information');
    if (!productInfo) return;

    /* Find the description RTE text block (last .rte in the product details sidebar) */
    var detailsCol = productInfo.querySelector('[class*="product-details"]') || productInfo;
    var rteBlocks = detailsCol.querySelectorAll('.text-block.rte');
    if (!rteBlocks.length) return;
    var descBlock = rteBlocks[rteBlocks.length - 1];

    /* Get utilisation content from hidden <template> rendered by product-details-luxe */
    var utilTemplate = document.getElementById('luxe-utilisation');
    var utilContent = utilTemplate ? utilTemplate.innerHTML.trim() : '';

    /* Get description content */
    var descContent = descBlock.innerHTML;

    /* Build tabs */
    var tabs = document.createElement('div');
    tabs.className = 'luxe-tabs';
    tabs.innerHTML =
      '<div class="luxe-tabs__nav">' +
        '<button class="luxe-tabs__tab active" data-tab="description" type="button">Description</button>' +
        '<button class="luxe-tabs__tab" data-tab="utilisation" type="button">Utilisation</button>' +
      '</div>' +
      '<div class="luxe-tabs__panel active" data-panel="description">' + descContent + '</div>' +
      '<div class="luxe-tabs__panel" data-panel="utilisation">' + utilContent + '</div>';

    /* Replace description block with tabs */
    descBlock.parentNode.replaceChild(tabs, descBlock);

    /* Tab switching */
    var tabButtons = tabs.querySelectorAll('.luxe-tabs__tab');
    var tabPanels = tabs.querySelectorAll('.luxe-tabs__panel');
    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabButtons.forEach(function (b) { b.classList.remove('active'); });
        tabPanels.forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        tabs.querySelector('[data-panel="' + btn.dataset.tab + '"]').classList.add('active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }
})();
